(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('DesktopScopeController', DesktopScopeController);

    DesktopScopeController.$inject = ['$scope'];

    function DesktopScopeController($scope) {
        init(null, $scope.vm.formData);
        $scope.$on('formDataReinitialized', init);

        // Initialize default values
        function init(event, formData) {
            var sectionData = formData.scope;

            if(typeof sectionData.useScopeOfAppraisal === 'undefined') {
                sectionData.useScopeOfAppraisal = true;
            }
        }
    }
})();
